import script from "./PopDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PopDialog.vue?vue&type=script&setup=true&lang=js"

import "./PopDialog.vue?vue&type=style&index=0&id=045c5aeb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-045c5aeb"]])

export default __exports__